module.exports = __webpack_public_path__ + "img/stock2.6ec5eab0.png";